module.exports = __webpack_public_path__ + "static/fonts/DINProBold.078f40bc.eot";